export const siteInfo = [
    `Deze website is gemaakt in opdracht van het Hoogwaterbeschermingsprogramma (HWBP) en is bedoeld om de duurzaamheidsambities van HWBP-projecten te ondersteunen.`,
    `De website is gebaseerd op de Duurzaamheidsroos, een instrument dat is ontwikkeld door HWBP.`,
];

export const expandHeaders = {
    site: "Site informatie",
    links: "Externe links",
    files: "Downloads",
};

export const handleiding = {
    label: "Handleiding",
    downloadFilename: "Handleiding dashboard duurzaamheid HWBP.pdf",
};

export const cookiePolicy = `
    Deze tool gebruikt alleen essentiële cookies. Deze cookies zijn nodig voor de werking van de website. 
    De cookies worden gebruikt om te gebruiker ingelogd te houden en voor beveiliging. 
    Deze cookies worden niet gebruikt voor advertentie, marketing, sociale media, tracking of analytics. 
    Deze cookies worden niet gedeeld met derden.
`;
